import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateRequestMarkdownState from './requestMarkdown';
import updateRequestState from './request';

const handlers = {
  ...updateRequestMarkdownState,
  ...updateRequestState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
